<template>
  <div class="forget-password">
    <div class="forget-password-card">
      <div class="title">
        <div class="logo"></div>
        {{ $t("r.resetPassword") }}
      </div>
      <div v-if="result == null" v-loading="sendingEmail" class="content">
        <div class="content-item">
          <p class="label">{{ $t("resetPass.email") }}</p>
          <div class="item">
            <el-input v-model="sendEmailParams.email" />
          </div>
        </div>
        <div class="content-item">
          <p class="label">{{ $t("resetPass.captcha") }}</p>
          <div class="item">
            <el-input
              v-model="sendEmailParams.verCode"
              style="width: 60%; margin-right: 10px"
            />
            <img
              :src="captchaUrl"
              :alt="$t('resetPass.changeCaptcha')"
              class="captcha-image"
              @click="refreshCaptcha"
            />
          </div>
        </div>
        <el-button
          type="primary"
          class="submit"
          color="#f332e3"
          @click="sendEmail"
          @keyup.enter="sendEmail"
        >
          {{ $t("resetPass.submit") }}
        </el-button>
        <el-link
          type="primary"
          class="returnLogin"
          @click="$router.push('/login')"
        >
          {{ $t("resetPass.returnLogin") }}
        </el-link>
      </div>
      <div v-else-if="result" class="content">
        <el-result
          icon="success"
          :title="$t('resetPass.success.title')"
          :sub-title="$t('resetPass.success.tip')"
        />
      </div>
      <div v-else-if="!result" class="content">
        <el-result
          icon="error"
          :title="$t('resetPass.fail.title')"
          :sub-title="$t('resetPass.fail.tip')"
        >
          <template #extra>
            <el-button type="primary" @click="result = null">
              {{ $t("resetPass.back") }}
            </el-button>
          </template>
        </el-result>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { getCaptchaApi } from "@/api/captcha/captchaApi";
import { sendResetPasswordEmailApi } from "@/api/manager/managerApi";
import { SendResetPasswordEmailParams } from "@/types/validator";
import { some } from "lodash-es";
import { onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";

const captchaUrl = ref<string>("");
const { locale } = useI18n();
const refreshCaptcha = async () => {
  const response = await getCaptchaApi();
  console.log(response);
  if (response) {
    console.log(response);
    sendEmailParams.captchaId = response.captchaId;
    captchaUrl.value = response.captchaImage; // 时间戳防止缓存
  } else {
    console.error("获取验证码失败");
  }
};

// 发送验证码
const sendEmailParams = reactive<SendResetPasswordEmailParams>({
  email: "",
  captchaId: "",
  verCode: "",
  locale: locale.value,
});

const result = ref<boolean | null>(null);
const sendingEmail = ref<boolean>(false);
const sendEmail = async () => {
  const flag = !some(sendEmailParams, (value) => {
    // 检查是否为 null、undefined 或者 trim() 结果为空字符串
    return value == null || (typeof value === "string" && value.trim() === "");
  });
  if (flag) {
    sendingEmail.value = true;
    const response = await sendResetPasswordEmailApi(sendEmailParams);
    sendingEmail.value = false;
    console.log(response);
    result.value = response;
  }
};

onMounted(() => {
  refreshCaptcha();
});
</script>
<style lang="less" scoped>
.forget-password {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: right;
  min-width: 800px;
  min-height: 600px;
  position: relative; /* 确保伪元素定位有效 */

  /* 移除直接的背景图片设置 */

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("@/assets/loginbg.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    transform: scaleX(-1); /* 水平翻转 */
    z-index: -1; /* 确保背景在内容后面 */
  }
}
.forget-password-card {
  width: 600px;
  height: 400px;
  position: relative;
  right: 10vw;
  background-color: #fff;
  box-shadow: 0 0 15px 1px rgba(247, 102, 181, 0.548);
  position: relative;
}
.logo {
  width: 120px;
  height: 30px;
  background-image: url("../assets/logo.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.title {
  background-color: #f332e3;
  height: 80px;
  width: 100%;
  display: flex;
  color: #ffffff;
  align-items: center;
  font-family: "SimHei";
  font-weight: bolder;
  letter-spacing: 1px;
  font-size: 24px;
  padding-left: 30px;
}
.captcha-image {
  cursor: pointer;
}
.content {
  display: flex;
  height: 280px;
  flex-direction: column;
  align-items: center;
  position: relative;
  justify-content: center;
}
.content-item {
  display: flex;
  width: 90%;
  height: 40px;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
}
.label {
  width: 30%;
  text-align: right;
  padding-right: 20px;
  font-family: "SimHei";
  letter-spacing: 1px;
  line-height: 40px;
  font-weight: bolder;
  font-size: 18px;
}
.item {
  width: 60%;
  display: flex;
  align-items: center;
}
.submit {
  width: 40%;
  height: 40px;
  font-size: 20px;
  font-family: "SimHei";
  font-weight: bolder;
  letter-spacing: 2px;
  margin-top: 20px;
}
.returnLogin {
  position: absolute;
  bottom: -20px;
  left: 30px;
}
</style>
